<section alertContainer>
  <section
    class="flex flex-col items-center justify-center w-full gap-3 select-none"
  >
    <app-icon name="solar:danger-circle-bold" class="text-red-600" />
    <p class="self-center text-xl font-semibold text-gray-800">비밀번호 찾기</p>
  </section>
  <p class="text-sm text-center text-gray-600 whitespace-pre-line">
    {{ props()?.text }}
  </p>
  <section class="flex gap-3 items-center">
    <app-button color="red" (click)="close()" expand>확인</app-button>
  </section>
</section>
